import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-epic-card",
  templateUrl: "./epic-card.component.html",
  styleUrls: ["./epic-card.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EpicCardComponent {
  env: any = environment;

  @Input() id: string;
  @Input() name: string;
  @Input() description: string;
  @Input() itemCount: number;
  @Input() attachmentCount: number;
  @Input() color: string;

  @Output() deleteClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/epic-card/epic-card.component.ts